import {MyTopPerformingGamesState} from '../../reducers/fortnite-game/myTopPerformingGames.reducer';

export const getMyTopPerformingGamesState = (state): MyTopPerformingGamesState => {
    return state.get('myTopPerformingGames').toJS();
};
